import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getWatchlistsQueryOptions } from "./get-watchlists";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";

export const removeCarFromWatchlist = async ({
  watchlistId,
  carId,
}: {
  watchlistId: string;
  carId: string;
}) => {
  return api.delete(`/carburate/watchlists/${watchlistId}/cars/${carId}`) as Promise<void>;
};

type UseRemoveCarFromWatchlistOptions = {
  mutationConfig?: MutationConfig<typeof removeCarFromWatchlist>;
};

export const useRemoveCarFromWatchlist = ({
  mutationConfig,
}: UseRemoveCarFromWatchlistOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      queryClient.refetchQueries({
        queryKey: getWatchlistsQueryOptions().queryKey,
      });
      // Invalidate the market car query so the UI (bell) reflects the change immediately
      const variables = args[1] as { watchlistId: string; carId: string } | undefined;
      if (variables?.carId) {
        queryClient.invalidateQueries({
          queryKey: ["market", "cars", variables.carId],
        });
      }
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: removeCarFromWatchlist,
  });
};
